import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { PlayerCommunityEvent } from '../../state/communityJackpot.types';

dayjs.extend(utc);
dayjs.extend(timezone);

export const formatJackpotEndDate = (event: PlayerCommunityEvent) =>
  dayjs(event.endDate).tz('America/Toronto').format('MMM DD, YYYY @ ha');
